<template>
	<modal
		:max-width="modalOptions.largura"
		:max-height="modalOptions.altura"
		:exibir="exibir"
		:custom-actions="true"
		:titulo="tituloModal"
		@close="fecharModal"
		:acao-cancelar="fecharModal"
		classe-personalizada-body="padding-body"
	>
		<template #body>
			<az-search
				class="justify-center py-3 padding-right-14 background-color"
				:filter="filtro"
				simple-search-placeholder="Busque por: nome ou órgão"
				@simple-search="buscar"
				ref="componenteAzSearch"
				@remove-filter="removerFiltros"
			>
			</az-search>
			<listagem-itens
				class="pa-6 pt-0 hidden-overflow"
				:itens="itens"
				:total-itens="totalItens"
				:total-paginas="totalPaginas"
				:textos-do-template-da-listagem-vazia="textosDoTemplateDaListagemVazia"
				:colunas="colunas"
				:tamanho-maximo-colunas="tamanhoMaximoColunas"
				:paginacao="paginacao"
				show-select
				:quantidade-itens-selecionados.sync="quantidadeItensSelecionados"
				:itens-selecionados.sync="itensSelecionados"
				@paginar="$emit('paginar', $event)"
				@resetar-page="$emit('resetar-page')"
			>
			</listagem-itens>
		</template>

		<template #actions>
			<v-card-actions class="bg-white my-2 py-2 justify-space-between">
				<botao-cancelar @cancelar="fecharModal"></botao-cancelar>
				<botao-adicionar @adicionar="adicionarItensSelecionados" :desabilitar="quantidadeItensSelecionados < 1">
					<template #label> ADICIONAR ({{ quantidadeItensSelecionados }}) </template>
				</botao-adicionar>
			</v-card-actions>
		</template>
	</modal>
</template>
<script>
import Modal from '@/views/components/Modal'
import BotaoAdicionar from '@/views/components/botoes/adicionar/BotaoAdicionar'
import BotaoCancelar from '@/views/components/BotaoCancelar'
import ListagemItens from '@/views/components/ListagemItens'
import tabelaMixin from '@/views/mixins/tabela'
import _ from 'lodash'

export default {
	name: 'modal-adicionar-entidades',
	components: {
		ListagemItens,
		BotaoCancelar,
		BotaoAdicionar,
		Modal,
	},
	mixins: [tabelaMixin],
	props: {
		exibir: {
			type: Boolean,
		},
		textosDoTemplateDaListagemVazia: {
			type: Object,
			required: true,
		},
		colunas: {
			type: Array,
			required: true,
		},
		itens: {
			type: Array,
			required: true,
		},
		modalOptions: {
			type: Object,
			default: () => {
				return { largura: '60%', altura: '80%' }
			},
		},
		tituloModal: {
			type: String,
			required: true,
		},
		tamanhoMaximoColunas: {
			type: Object,
			default: () => {},
		},
		filtro: {
			type: Object,
			required: true,
		},
	},
	emits: ['paginar', 'resetar-page', 'fechar-modal', 'set-filtro', 'adicionar-itens-selecionados'],
	data() {
		return {
			quantidadeItensSelecionados: 0,
			itensSelecionados: [],
			filtroInterno: _.clone(this.filtro),
		}
	},
	async mounted() {},
	methods: {
		async buscar(searchText) {
			if (searchText) {
				this.filtroInterno[Object.keys(this.filtroInterno).at(0)].value = searchText.trim()
			}

			this.$emit('set-filtro', this.filtroInterno)
			this.$emit('resetar-page')
		},
		async removerFiltros(propriedade) {
			if (this.filtroInterno[propriedade]) {
				this.filtroInterno[propriedade].value = this.filtroInterno[propriedade].default
			}
			this.$emit('set-filtro', this.filtroInterno)
			this.$emit('resetar-page')
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		adicionarItensSelecionados() {
			this.$emit('adicionar-itens-selecionados', this.itensSelecionados)
		},
	},
}
</script>

<style lang="stylus">
.bg-white
	background-color white

.padding-body
	padding 0 !important

.v-dialog--active:has(.hidden-overflow)
	overflow hidden !important

.padding-right-14
	padding-right 14px

.background-color
	background-color #F2F7FA
</style>
